import { Languages } from "../../enums/languages";
import { formatCurrencyNis } from "../../helpers/formating-currency";

const addRequestPageLang = {
    "page-title": {
        [Languages.Hebrew]: { default: "טופס בקשה לתו חניה" },
        [Languages.English]: { default: "Parking Permit Request Form" },
        [Languages.Arabic]: { default: "نموذج طلب تصريح موقف السيارات" }
    },
    "form": {
        "personal-details-section": {
            "title": {
                [Languages.Hebrew]: { default: "פרטי המבקש" },
                [Languages.English]: { default: "Personal Details" },
                [Languages.Arabic]: { default: "تفاصيل شخصية" }
            },
            "privateNameLabel": {
                [Languages.Hebrew]: { default: "שם פרטי" },
                [Languages.English]: { default: "Private Name" },
                [Languages.Arabic]: { default: "الاسم الخاص" }
            },
            "familyNameLabel": {
                [Languages.Hebrew]: { default: "שם משפחה" },
                [Languages.English]: { default: "Family Name" },
                [Languages.Arabic]: { default: "اسم العائلة" }
            },
            "idLabel": {
                [Languages.Hebrew]: { default: "מספר תעודת זהות" },
                [Languages.English]: { default: "ID Number" },
                [Languages.Arabic]: { default: "رقم الهوية" }
            },
            "personFileLabel": {
                [Languages.Hebrew]: { default: "צילום תעודת זהות וספח" },
                [Languages.English]: { default: "ID Photo" },
                [Languages.Arabic]: { default: "صورة الهوية" }
            },
            "personFileLabelWithAdditionalFile": {
                [Languages.Hebrew]: { default: "צילום תעודת זהות בלי ספח" },
                [Languages.English]: { default: "ID without Additional File" },
                [Languages.Arabic]: { default: "الهوية بدون ملف إضافي" }
            },
            "additionalPersonIdFileLabel": {
                [Languages.Hebrew]: { default: "צילום ספח תעודת זהות" },
                [Languages.English]: { default: "Additional ID File" },
                [Languages.Arabic]: { default: "ملف هوية إضافي" }
            }
        },
        "car-details-section": {
            "title": {
                [Languages.Hebrew]: { default: "פרטי הרכב" },
                [Languages.English]: { default: "Car Details" },
                [Languages.Arabic]: { default: "تفاصيل السيارة" }
            },
            "carIdLabel": {
                [Languages.Hebrew]: { default: "מספר רכב" },
                [Languages.English]: { default: "Car Number" },
                [Languages.Arabic]: { default: "رقم السيارة" }
            },
            "ownershipCarLabel": {
                [Languages.Hebrew]: { default: "בעלות רכב" },
                [Languages.English]: { default: "Car Ownership" },
                [Languages.Arabic]: { default: "ملكية السيارة" }
            },
            "privateCarLabel": {
                [Languages.Hebrew]: { default: "רכב פרטי" },
                [Languages.English]: { default: "Private Car" },
                [Languages.Arabic]: { default: "سيارة خاصة" }
            },
            "companyCarLabel": {
                [Languages.Hebrew]: { default: "רכב חברה/בעלות אחרת" },
                [Languages.English]: { default: "Company Car/Other Ownership" },
                [Languages.Arabic]: { default: "سيارة الشركة / ملكية أخرى" }
            },
            "scanCarIdLabel": {
                [Languages.Hebrew]: { default: "צילום רשיון רכב(שים לב לא רשיון נהיגה!)" },
                [Languages.English]: { default: "Car License Photo (Note: Not a driver's license!)" },
                [Languages.Arabic]: { default: "صورة رخصة السيارة (ملاحظة: ليست رخصة قيادة!)" }
            },
            "scanWorkStatementLabel": {
                [Languages.Hebrew]: { default: "צילום הצהרה ממקום העבודה/מחברת הליסינג/של בן משפחה/תצהיר שימוש ברכב" },
                [Languages.English]: { default: "Work Statement Photo from Workplace/Leasing Company/Family Member/Car Usage Declaration" },
                [Languages.Arabic]: { default: "صورة بيان من مكان العمل / شركة التأجير / أحد أفراد الأسرة / إعلان استخدام السيارة" }
            }
        },
        "contact-details-section": {
            "title": {
                [Languages.Hebrew]: { default: "פרטי הכתובת" },
                [Languages.English]: { default: "Contact Details" },
                [Languages.Arabic]: { default: "تفاصيل الاتصال" }
            },
            "streetLabel": {
                [Languages.Hebrew]: { default: "רחוב" },
                [Languages.English]: { default: "Street" },
                [Languages.Arabic]: { default: "شارع" }
            },
            "houseLabel": {
                [Languages.Hebrew]: { default: "בית" },
                [Languages.English]: { default: "House" },
                [Languages.Arabic]: { default: "منزل" }
            },
            "apartmentLabel": {
                [Languages.Hebrew]: { default: "דירה" },
                [Languages.English]: { default: "Apartment" },
                [Languages.Arabic]: { default: "شقة" }
            },
            "emailLabel": {
                [Languages.Hebrew]: { default: "דואר אלקטרוני" },
                [Languages.English]: { default: "Email" },
                [Languages.Arabic]: { default: "البريد الإلكتروني" }
            },
            "mobileLabel": {
                [Languages.Hebrew]: { default: "טלפון נייד" },
                [Languages.English]: { default: "Mobile Phone" },
                [Languages.Arabic]: { default: "الهاتف المحمول" }
            },
            "phoneLabel": {
                [Languages.Hebrew]: { default: "טלפון נוסף" },
                [Languages.English]: { default: "Additional Phone" },
                [Languages.Arabic]: { default: "هاتف إضافي" }
            }
        },
        "additional-address-section": {
            "title": {
                [Languages.Hebrew]: { default: "כתובת נוספת" },
                [Languages.English]: { default: "Additional Address" },
                [Languages.Arabic]: { default: "عنوان إضافي" }
            },
            "cityLabel": {
                [Languages.Hebrew]: { default: "עיר למשלוח" },
                [Languages.English]: { default: "City for Shipping" },
                [Languages.Arabic]: { default: "المدينة للشحن" }
            },
            "streetLabel": {
                [Languages.Hebrew]: { default: "רחוב" },
                [Languages.English]: { default: "Street" },
                [Languages.Arabic]: { default: "شارع" }
            },
            "houseLabel": {
                [Languages.Hebrew]: { default: "בית" },
                [Languages.English]: { default: "House" },
                [Languages.Arabic]: { default: "منزل" }
            },
            "apartmentLabel": {
                [Languages.Hebrew]: { default: "דירה" },
                [Languages.English]: { default: "Apartment" },
                [Languages.Arabic]: { default: "شقة" }
            },
            "postalCodeLabel": {
                [Languages.Hebrew]: { default: "מיקוד" },
                [Languages.English]: { default: "Postal Code" },
                [Languages.Arabic]: { default: "الرمز البريدي" }
            },
            "additionalAddressLabel": {
                [Languages.Hebrew]: { default: "האם קיימת כתובת שונה למשלוח תו חנייה?" },
                [Languages.English]: { default: "Is there a different address for sending the parking permit?" },
                [Languages.Arabic]: { default: "هل هناك عنوان مختلف لإرسال تصريح وقوف السيارات؟" }
            },
            "yesLabel": {
                [Languages.Hebrew]: { default: "כן" },
                [Languages.English]: { default: "Yes" },
                [Languages.Arabic]: { default: "نعم" }
            },
            "noLabel": {
                [Languages.Hebrew]: { default: "לא" },
                [Languages.English]: { default: "No" },
                [Languages.Arabic]: { default: "لا" }
            }
        },
        "files-section": {
            "title": {
                [Languages.Hebrew]: { default: "קבצים נוספים" },
                [Languages.English]: { default: "Additional Files" },
                [Languages.Arabic]: { default: "ملفات إضافية" }
            },
            "additionalFileLabel": {
                [Languages.Hebrew]: { default: "קובץ נוסף?" },
                [Languages.English]: { default: "Additional File?" },
                [Languages.Arabic]: { default: "ملف إضافي؟" }
            },
            "is-rent-app-title": {
                [Languages.Hebrew]: { default: "שוכר דירה" },
                [Languages.English]: { default: "Renting Apartment" },
                [Languages.Arabic]: { default: "استئجار شقة" }
            },
            "rent-contract-label": {
                [Languages.Hebrew]: { default: "אנא סרוק חוזה שכירות" },
                [Languages.English]: { default: "Please scan the rent contract" },
                [Languages.Arabic]: { default: "يرجى مسح عقد الإيجار ضوئيًا" }
            },
            "property-tax-bill-label": {
                [Languages.Hebrew]: { default: "סרוק שובר חיוב ארנונה אחרון" },
                [Languages.English]: { default: "Scan the latest property tax bill" },
                [Languages.Arabic]: { default: "امسح أحدث فاتورة ضريبة الممتلكات ضوئيًا" }
            },
            "yesLabel": {
                [Languages.Hebrew]: { default: "כן" },
                [Languages.English]: { default: "Yes" },
                [Languages.Arabic]: { default: "نعم" }
            },
            "noLabel": {
                [Languages.Hebrew]: { default: "לא" },
                [Languages.English]: { default: "No" },
                [Languages.Arabic]: { default: "لا" }
            },
            "has-business-title": {
                [Languages.Hebrew]: { default: "עסק רשום בעיר?" },
                [Languages.English]: { default: "Registered Business in the City?" },
                [Languages.Arabic]: { default: "هل هناك عمل مسجل في المدينة؟" }
            },
            "business-tax-bill-label": {
                [Languages.Hebrew]: { default: "סרוק ארנונה על שם העסק" },
                [Languages.English]: { default: "Scan the business property tax bill" },
                [Languages.Arabic]: { default: "امسح فاتورة ضريبة الممتلكات باسم العمل" }
            }
        },
        "payment-section": {
            "title": {
                [Languages.Hebrew]: { default: "פרטי תשלום" },
                [Languages.English]: { default: "Payment Details" },
                [Languages.Arabic]: { default: "تفاصيل الدفع" }
            },
            "card-number-label": {
                [Languages.Hebrew]: { default: "מספר כרטיס אשראי" },
                [Languages.English]: { default: "Credit Card Number" },
                [Languages.Arabic]: { default: "رقم بطاقة الائتمان" }
            },
            "card-expire-year-label": {
                [Languages.Hebrew]: { default: "שנת תפוגה" },
                [Languages.English]: { default: "Expiration Year" },
                [Languages.Arabic]: { default: "سنة الانتهاء" }
            },
            "card-expire-month-label": {
                [Languages.Hebrew]: { default: "חודש תפוגה" },
                [Languages.English]: { default: "Expiration Month" },
                [Languages.Arabic]: { default: "شهر الانتهاء" }
            },
            "card-cvv-label": {
                [Languages.Hebrew]: { default: "CVV" },
                [Languages.English]: { default: "CVV" },
                [Languages.Arabic]: { default: "CVV" }
            },
            "card-holder-id-label": {
                [Languages.Hebrew]: { default: "תעודת זהות של בעל הכרטיס" },
                [Languages.English]: { default: "Card Holder's ID" },
                [Languages.Arabic]: { default: "هوية حامل البطاقة" }
            },
            "card-holder-name-label": {
                [Languages.Hebrew]: { default: "שם על גבי הכרטיס(באנגלית)" },
                [Languages.English]: { default: "Name on the Card (in English)" },
                [Languages.Arabic]: { default: "الاسم على البطاقة (بالإنجليزية)" }
            },
        },
        "permit-types": {
            "title": {
                [Languages.Hebrew]: { default: "סוגי היתרים" },
                [Languages.English]: { default: "Permit Types" },
                [Languages.Arabic]: { default: "أنواع التصاريح" }
            },
            "disabled-parking-tag": {
                "title-tag": {
                    [Languages.Hebrew]: { default: "תו נכה" },
                    [Languages.English]: { default: "Disabled Parking Tag" },
                    [Languages.Arabic]: { default: "إعاقة" }
                },
                "options": {
                    "yesLabel": {
                        [Languages.Hebrew]: { default: "כן" },
                        [Languages.English]: { default: "Yes" },
                        [Languages.Arabic]: { default: "نعم" }
                    },
                    "noLabel": {
                        [Languages.Hebrew]: { default: "לא" },
                        [Languages.English]: { default: "No" },
                        [Languages.Arabic]: { default: "لا" }
                    }
                }
            },
            "student-parking-tag": {
                "title-tag": {
                    [Languages.Hebrew]: { default: "תו סטודנט" },
                    [Languages.English]: { default: "Student Parking Tag" },
                    [Languages.Arabic]: { default: "تصريح وقوف الطلاب" }
                },
                "options": {
                    "yesLabel": {
                        [Languages.Hebrew]: { default: "כן" },
                        [Languages.English]: { default: "Yes" },
                        [Languages.Arabic]: { default: "نعم" }
                    },
                    "noLabel": {
                        [Languages.Hebrew]: { default: "לא" },
                        [Languages.English]: { default: "No" },
                        [Languages.Arabic]: { default: "لا" }
                    }
                },
                "additional-file-label": {
                    [Languages.Hebrew]: { default: "צילום תעודת סטודנט" },
                    [Languages.English]: { default: "Student ID Photo" },
                    [Languages.Arabic]: { default: "صورة هوية الطالب" }
                }
            },
            "golden-age-permit": {
                "title-tag": {
                    [Languages.Hebrew]: { default: "מעל גיל " },
                    [Languages.English]: { default: "Above Age " },
                    [Languages.Arabic]: { default: "فوق عمر " }
                },
                "options": {
                    "yesLabel": {
                        [Languages.Hebrew]: { default: "כן" },
                        [Languages.English]: { default: "Yes" },
                        [Languages.Arabic]: { default: "نعم" }
                    },
                    "noLabel": {
                        [Languages.Hebrew]: { default: "לא" },
                        [Languages.English]: { default: "No" },
                        [Languages.Arabic]: { default: "لا" }
                    }
                }
            },
            "business-permit": {
                "title-tag": {
                    [Languages.Hebrew]: { default: "בקשת התו עבור עסק בעיר?" },
                    [Languages.English]: { default: "Business Permit" },
                    [Languages.Arabic]: { default: "تصريح تجاري" }
                },
                "options": {
                    "yesLabel": {
                        [Languages.Hebrew]: { default: "כן" },
                        [Languages.English]: { default: "Yes" },
                        [Languages.Arabic]: { default: "نعم" }
                    },
                    "noLabel": {
                        [Languages.Hebrew]: { default: "לא" },
                        [Languages.English]: { default: "No" },
                        [Languages.Arabic]: { default: "لا" }
                    }
                }
            },
            "zone-permit": {
                "title-tag": {
                    [Languages.Hebrew]: {
                        32: "האם אתה/ת גר/ה ברחוב אל-ג'ליל צמוד רחוב?",
                        default: "בקשת התו לפי אזור בעיר?"
                    },
                    [Languages.English]: {
                        32: "Are you living on Al-Jalil Street adjacent to the street?",
                        default: "Zone Permit"
                    },
                    [Languages.Arabic]: { default: "تصريح حسب المنطقة" }
                },
                "options": {
                    "yesLabel": {
                        [Languages.Hebrew]: { default: "כן" },
                        [Languages.English]: { default: "Yes" },
                        [Languages.Arabic]: { default: "نعم" }
                    },
                    "noLabel": {
                        [Languages.Hebrew]: { default: "לא" },
                        [Languages.English]: { default: "No" },
                        [Languages.Arabic]: { default: "لا" }
                    }
                }
            }
        },
    },
    "send-form-btn": {
        [Languages.Hebrew]: { default: "שלח טופס" },
        [Languages.English]: { default: "Send Form" },
        [Languages.Arabic]: { default: "إرسال النموذج" }
    },
    "takanon": {
        "title": {
            [Languages.Hebrew]: { default: "הצהרת המבקש/ת" },
            [Languages.English]: { default: "Applicant's Declaration" },
            [Languages.Arabic]: { default: "إعلان المتقدم" }
        },
        "takanon-check-box": {
            [Languages.Hebrew]: { default: "קראתי ואני מאשר את התנאים וההגבלות" },
            [Languages.English]: { default: "I have read and agree to the terms and conditions" },
            [Languages.Arabic]: { default: "لقد قرأت وأوافق على الشروط والأحكام" }
        },
        "default": {
            "line-1": {
                [Languages.Hebrew]: { default: "הריני מצהיר בזאת כי כל הפרטים לעיל נכונים ומלאים." },
                [Languages.English]: { default: "I hereby declare that all the above details are correct and complete." },
                [Languages.Arabic]: { default: "أصرح بموجب هذا أن جميع التفاصيل أعلاه صحيحة وكاملة." }
            },
            "line-2": {
                [Languages.Hebrew]: { default: "ידוע לי כי דיווח חלקי או כוזב הינה עבירה על החוק, וכן ידוע לי כי לרשות יש זכות לבדוק את נכונות הפרטים הנ\"ל בכל האמצעים העומדים לרשותה כחוק." },
                [Languages.English]: { default: "I am aware that partial or false reporting is an offense under the law, and I am also aware that the authority has the right to verify the accuracy of the above details by all means available to it by law." },
                [Languages.Arabic]: { default: "أنا على علم بأن الإبلاغ الجزئي أو الكاذب يعد جريمة بموجب القانون، وأنا على علم أيضًا بأن للسلطة الحق في التحقق من صحة التفاصيل أعلاه بجميع الوسائل المتاحة لها بموجب القانون." }
            },
            "line-3": {
                [Languages.Hebrew]: { default: "הנני מאשר להשתמש בפרטים שהוזנו על ידי במסגרת הבקשה לצרכי המועצה על פי כל דין. אני מעוניין/ת לקבל תזכורות במסרון או אימייל." },
                [Languages.English]: { default: "I consent to the use of the details entered by me in the application for the council's purposes according to any law. I wish to receive reminders via SMS or email." },
                [Languages.Arabic]: { default: "أوافق على استخدام التفاصيل التي أدخلتها في الطلب لأغراض المجلس وفقًا لأي قانون. أرغب في تلقي التذكيرات عبر الرسائل القصيرة أو البريد الإلكتروني." }
            },
        },
        "projectId69": {
            "title": {
                [Languages.Hebrew]: { default: "תו החנייה הדיגיטלי הוא לשנה יש להגיש בקשה חדשה בחלוף שנה ממועד קבלת התו" },
                [Languages.English]: { default: "The digital parking permit is valid for one year. A new application must be submitted after one year from the date of receiving the permit." },
                [Languages.Arabic]: { default: "تصريح وقوف السيارات الرقمي صالح لمدة عام واحد. يجب تقديم طلب جديد بعد عام واحد من تاريخ استلام التصريح." }
            },
            "line1": {
                [Languages.Hebrew]: { default: "הצהרת המבקש/ת" },
                [Languages.English]: { default: "Applicant's Declaration" },
                [Languages.Arabic]: { default: "إعلان المتقدم" }
            },
            "line2": {
                [Languages.Hebrew]: { default: "• המבקש נדרש להעביר למועצה הודעה בכתב עם מכירת הרכב או החזרת הרכב / ליסינג רכב עבודה ." },
                [Languages.English]: { default: "• The applicant is required to send a written notice to the council upon selling the car or returning the car / leasing a work car." },
                [Languages.Arabic]: { default: "• يجب على المتقدم إرسال إشعار كتابي إلى المجلس عند بيع السيارة أو إرجاع السيارة / تأجير سيارة للعمل." }
            },
            "line3": {
                [Languages.Hebrew]: { default: "• המבקש נדרש להעביר הודעה למועצה על שינוי מגורים, כתובת מקום המגורים." },
                [Languages.English]: { default: "• The applicant is required to send a notice to the council about changing residence, address of residence." },
                [Languages.Arabic]: { default: "• يجب على المتقدم إرسال إشعار إلى المجلس حول تغيير السكن، عنوان السكن." }
            },
            "line4": {
                [Languages.Hebrew]: { default: "• הנני מצהיר, כי כל המידע המפורט בבקשה ובמסמכים המצורפים לה נכון. ידוע לי כי מסירת פרטים כוזבים לעניין הגשת הבקשה ושימוש בתו שלא בהתאם להתחייבותי כמפורט למעלה הינם עבירה על החוק וזכות השימוש בתו תפקע ולמועצה תהיה הזכות לבטל את התו ליתר הסועדים העומדים לרשותה, לידיעתך המידע שנמסר על ידך בטופס זה נשמר במאגרי המידע של המועצה על מנת לתת לך שירות מטעמה." },
                [Languages.English]: { default: "• I declare that all the information detailed in the application and the attached documents is correct. I am aware that providing false details regarding the submission of the application and using the permit not in accordance with my commitment as detailed above is an offense under the law, and the right to use the permit will be revoked and the council will have the right to cancel the permit for the rest of the users at its disposal. For your information, the information you provided in this form is stored in the council's databases in order to provide you with service on its behalf." },
                [Languages.Arabic]: { default: "• أصرح بأن جميع المعلومات المفصلة في الطلب والمستندات المرفقة صحيحة. أنا على علم بأن تقديم تفاصيل كاذبة بشأن تقديم الطلب واستخدام التصريح ليس وفقًا لالتزامي كما هو مفصل أعلاه هو جريمة بموجب القانون، وسيتم إلغاء حق استخدام التصريح وسيكون للمجلس الحق في إلغاء التصريح لبقية المستخدمين المتاحين لديه. لمعلوماتك، يتم تخزين المعلومات التي قدمتها في هذا النموذج في قواعد بيانات المجلس من أجل تقديم الخدمة لك نيابة عنه." }
            },
            "line5": {
                [Languages.Hebrew]: { default: "קראתי את ההצהרה ואני מסכים/ה לתנאים." },
                [Languages.English]: { default: "I have read the declaration and I agree to the terms." },
                [Languages.Arabic]: { default: "لقد قرأت الإعلان وأوافق على الشروط." }
            }
        },
        "projectId26": {
            "title": {
                [Languages.Hebrew]: { default: "עם רכישת תו החנייה הרני מצהיר ומתחייב:" },
                [Languages.English]: { default: "Upon purchasing the parking permit, I hereby declare and undertake:" },
                [Languages.Arabic]: { default: "عند شراء تصريح وقوف السيارات، أصرح وأتعهد بموجب هذا:" }
            },
            "line1": {
                [Languages.Hebrew]: { default: "1. להדביק את המדבקה על השמשה הקדמית בצד ימין של רכבי (שתהיה גלויה לעין) ולשמור על שלמותה." },
                [Languages.English]: { default: "1. To affix the sticker on the front windshield on the right side of my vehicle (so that it is visible to the eye) and to maintain its integrity." },
                [Languages.Arabic]: { default: "1. لصق الملصق على الزجاج الأمامي على الجانب الأيمن من مركبتي (بحيث يكون مرئيًا للعين) والحفاظ على سلامته." }
            },
            "line2": {
                [Languages.Hebrew]: { default: "2. להסיר את המדבקה מהרכב עם שינוי מקום מגוריי (מחוץ לעיר עפולה ו/או לרחוב בעיר עפולה שאינו עולה בקנה אחד עם הזכויות שתו החנייה מקנה) ו/או עם מכירתו ו/או העברתו לאחר ו/או עם החזרת הרכב למקום עבודתי ו/או עם פקיעת תוקף התו המוטבע עליו." },
                [Languages.English]: { default: "2. To remove the sticker from the vehicle with a change of residence (outside the city of Afula and/or to a street in the city of Afula that is not consistent with the rights granted by the parking permit) and/or with its sale and/or transfer to another and/or with returning the vehicle to my workplace and/or with the expiration of the validity of the permit embedded on it." },
                [Languages.Arabic]: { default: "2. لإزالة الملصق من المركبة مع تغيير السكن (خارج مدينة أفولا و/أو إلى شارع في مدينة أفولا لا يتوافق مع الحقوق التي يمنحها تصريح وقوف السيارات) و/أو مع بيعه و/أو نقله إلى آخر و/أو مع إعادة السيارة إلى مكان عملي و/أو مع انتهاء صلاحية التصريح المدمج عليه." }
            },
            "line3": {
                [Languages.Hebrew]: { default: "3. לא להעביר את המדבקה לאחר." },
                [Languages.English]: { default: "3. Not to transfer the sticker to another." },
                [Languages.Arabic]: { default: "3. عدم نقل الملصق إلى آخر." }
            },
            "line4": {
                [Languages.Hebrew]: { default: "הנני מצהיר, כי כל המידע המפורט בבקשתי לקבלת המדבקה ובמסמכים המצורפים אליה נכון, מלא ומדוייק. ידוע לי, כי מסרתי פרטים כוזבים לעיניין הגשת הבקשה והשימוש במדבקה שלא בהתאם להתחייבותי כמפורט למעלה הינם עבירה על החוק - דבק אשר עשוי להוביל להגשת תלונה למשטרת ישראל, ועיריית עפולה תהיה הזכות לבטל את המדברקה ו/או את הזכיותיי לפיה ו/או את זכותי לקבלת תו חנייה חדש." },
                [Languages.English]: { default: "I declare that all the information detailed in my request for the sticker and the documents attached to it is correct, complete and accurate. I am aware that providing false details regarding the submission of the application and using the sticker not in accordance with my commitment as detailed above is an offense under the law - an offense that may lead to filing a complaint with the Israeli police, and the Afula municipality will have the right to cancel the sticker and/or my rights to it and/or my right to receive a new parking permit." },
                [Languages.Arabic]: { default: "أصرح بأن جميع المعلومات المفصلة في طلبي للحصول على الملصق والمستندات المرفقة به صحيحة وكاملة ودقيقة. أنا على علم بأن تقديم تفاصيل كاذبة بشأن تقديم الطلب واستخدام الملصق ليس وفقًا لالتزامي كما هو مفصل أعلاه هو جريمة بموجب القانون - جريمة قد تؤدي إلى تقديم شكوى إلى الشرطة الإسرائيلية، وسيكون لدى بلدية أفولا الحق في إلغاء الملصق و/أو حقوقي فيه و/أو حقي في الحصول على تصريح وقوف جديد." }
            }
        },
        "projectId94": {
            "title": {
                [Languages.Hebrew]: { default: "הצהרת המבקש" },
                [Languages.English]: { default: "Applicant's Declaration" },
                [Languages.Arabic]: { default: "إعلان المتقدم" }
            },
            "line1": {
                [Languages.Hebrew]: { default: 'אני מתחייב בזאת כי במידה ואמכור את רכבי הנ"ל ו/או אעתיק את מגוריי אדווח על כך תוך 7 ימים לרשות החניה והפיקוח של עיריית קריית ביאליק.' },
                [Languages.English]: { default: "I hereby undertake that if I sell the aforementioned vehicle and/or change my residence, I will report it within 7 days to the Parking and Supervision Authority of the Kiryat Bialik Municipality." },
                [Languages.Arabic]: { default: "أتعهد بموجب هذا أنه إذا بعت السيارة المذكورة أعلاه و/أو غيرت محل إقامتي، سأبلغ عن ذلك خلال 7 أيام إلى سلطة الوقوف والإشراف في بلدية كريات بياليك." }
            },
            "line2": {
                [Languages.Hebrew]: { default: "1. אם בבעלותך רכב נוסף-יש להגיש טופס נוסף." },
                [Languages.English]: { default: "1. If you own an additional vehicle - you must submit an additional form." },
                [Languages.Arabic]: { default: "1. إذا كنت تمتلك سيارة إضافية - يجب عليك تقديم نموذج إضافي." }
            },
            "line3": {
                [Languages.Hebrew]: { default: "2. בעת רכישת רכב חדש-יש להגיש טופס חדש." },
                [Languages.English]: { default: "2. When purchasing a new vehicle - you must submit a new form." },
                [Languages.Arabic]: { default: "2. عند شراء سيارة جديدة - يجب عليك تقديم نموذج جديد." }
            },
            "line4": {
                [Languages.Hebrew]: { default: "3. בעת שינוי מגורים-יש להגיש טופס חדש." },
                [Languages.English]: { default: "3. When changing residence - you must submit a new form." },
                [Languages.Arabic]: { default: "3. عند تغيير السكن - يجب عليك تقديم نموذج جديد." }
            }
        },
        "projectId25": {
            "title": {
                [Languages.Hebrew]: { default: " לידיעתך," },
                [Languages.English]: { default: "For your information," },
                [Languages.Arabic]: { default: "لمعلوماتك،" }
            },
            "line-1": {
                [Languages.Hebrew]: { default: "1. במילוי הטופס בלבד, אין הרשות מתחייבת להפקת התו המבוקש, אלא בהתאם לנהליה ולאישור שישלח למייל שצויין בבקשה." },
                [Languages.English]: { default: "1. By filling out the form only, the authority does not commit to issuing the requested permit, but according to its regulations and the approval that will be sent to the email specified in the request." },
                [Languages.Arabic]: { default: "1. عند ملء النموذج فقط، لا تلتزم السلطة بإصدار التصريح المطلوب، ولكن وفقًا للوائحها والموافقة التي سيتم إرسالها إلى البريد الإلكتروني المحدد في الطلب." }
            },
            "line-2": {
                [Languages.Hebrew]: { default: "2. תו החניה הונפק על פי מס רכב, בעת מכירת רכב ו/או החזרת הרכב למקום העבודה יש ליצור קשר עם המחלקה המנפיקה ברשות." },
                [Languages.English]: { default: "2. The parking permit was issued according to the vehicle number. When selling a vehicle and/or returning the vehicle to the workplace, please contact the issuing department at the authority." },
                [Languages.Arabic]: { default: "2. تم إصدار تصريح الوقوف وفقًا لرقم السيارة. عند بيع سيارة و/أو إعادة السيارة إلى مكان العمل، يرجى الاتصال بالقسم المصدر في السلطة." }
            },
            "line-3": {
                [Languages.Hebrew]: { default: "3. תו החניה הונפק בהתאם לכתובת המגורים שהצהרת, עם שינוי כתובת המגורים יש ליצור קשר עם המחלקה המנפיקה ברשות." },
                [Languages.English]: { default: "3. The parking permit was issued according to the residence address you declared, with a change of residence address please contact the issuing department at the authority." },
                [Languages.Arabic]: { default: "3. تم إصدار تصريح الوقوف وفقًا لعنوان السكن الذي أعلنته، مع تغيير عنوان السكن يرجى الاتصال بالقسم المصدر في السلطة." }
            },
            "line-4": {
                [Languages.Hebrew]: { default: "בשליחת הבקשה, הינך מאשר/ת את ההצהרה הבאה:" },
                [Languages.English]: { default: "By submitting the request, you confirm the following declaration:" },
                [Languages.Arabic]: { default: "عند تقديم الطلب، تؤكد الإعلان التالي:" }
            },
            "line-5": {
                [Languages.Hebrew]: { default: "הנני מצהיר/ה, כי כל המידע המפורט בבקשה ובמסמכים המצורפים לה נכון." },
                [Languages.English]: { default: "I declare that all the information provided in the application and the attached documents is correct." },
                [Languages.Arabic]: { default: "أصرح بأن جميع المعلومات المقدمة في الطلب والمستندات المرفقة صحيحة." }
            },
            "line-6": {
                [Languages.Hebrew]: { default: " ידוע לי כי מסירת פרטים כוזבים לעניין הגשת הבקשה ושימוש בתו שלא בהתאם להתחייבותי כמפורט למעלה עלולים להוות עבירה על החוק וזכות השימוש בתו תפקע ולעירייה תהיה הזכות לבטל את התו, וזאת בנוסף ליתר הסעדים העומדים לרשותה על – פי דין." },
                [Languages.English]: { default: "I am aware that providing false details regarding the submission of the application and using the permit not in accordance with my commitment as detailed above is an offense under the law, and the right to use the permit will be revoked and the council will have the right to cancel the permit, in addition to other remedies available to it by law." },
                [Languages.Arabic]: { default: "أنا على علم بأن تقديم تفاصيل كاذبة بشأن تقديم الطلب واستخدام التصريح ليس وفقًا لالتزامي كما هو مفصل أعلاه هو جريمة بموجب القانون، وسيتم إلغاء حق استخدام التصريح وسيكون للمجلس الحق في إلغاء التصريح، بالإضافة إلى غيرها من العلاجات المتاحة له بموجب القانون." }
            },
            "line-7": {
                [Languages.Hebrew]: { default: "לידיעתך, המידע שנמסר על ידך בטופס זה, נשמר במאגרי המידע של העירייה על מנת לתת לך שירות מטעמה." },
                [Languages.English]: { default: "For your information, the information you provided in this form is stored in the municipality's databases in order to provide you with service on its behalf." },
                [Languages.Arabic]: { default: "لمعلوماتك، يتم تخزين المعلومات التي قدمتها في هذا النموذج في قواعد بيانات البلدية من أجل تقديم الخدمة لك نيابة عنها." }
            }
        },
        "projectId87": {
            "line-1": {
                [Languages.Hebrew]: { default: "הריני מצהיר בזאת כי כל הפרטים לעיל נכונים ומלאים." },
                [Languages.English]: { default: "I declare that all the details above are correct and complete." },
                [Languages.Arabic]: { default: "أصرح بأن جميع التفاصيل أعلاه صحيحة وكاملة." }
            },
            "line-2": {
                [Languages.Hebrew]: { default: "ידוע לי כי דיווח חלקי או כוזב הינה עבירה על החוק, וכן ידוע לי כי לרשות יש זכות לבדוק את נכונות הפרטים הנל בכל האמצעים העומדים לרשותה כחוק." },
                [Languages.English]: { default: "I am aware that providing false details regarding the submission of the application and using the permit not in accordance with my commitment as detailed above is an offense under the law, and the right to use the permit will be revoked and the council will have the right to cancel the permit, in addition to other remedies available to it by law." },
                [Languages.Arabic]: { default: "أنا على علم بأن تقديم تفاصيل كاذبة بشأن تقديم الطلب واستخدام التصريح ليس وفقًا لالتزامي كما هو مفصل أعلاه هو جريمة بموجب القانون، وسيتم إلغاء حق استخدام التصريح وسيكون للمجلس الحق في إلغاء التصريح، بالإضافة إلى غيرها من العلاجات المتاحة له بموجب القانون." }
            },
            "line-3": {
                [Languages.Hebrew]: { default: "הנני מאשר להשתמש בפרטים שהוזנו על ידי במסגרת הבקשה לצרכי המועצה על פי כל דין. אני מעוניין/ת לקבל תזכורות במסרון או אימייל." },
                [Languages.English]: { default: "I authorize the use of the details provided by me within the framework of the request for the purposes of the council according to the law. I wish to receive reminders via SMS or email." },
                [Languages.Arabic]: { default: "أوافق على استخدام التفاصيل التي قدمتها في إطار الطلب لأغراض المجلس وفقًا للقانون. أرغب في تلقي التذكيرات عبر الرسائل القصيرة أو البريد الإلكتروني." }
            },
        },
        "projectId12": {
            "line-1": {
                [Languages.Hebrew]: { default: "הריני מצהיר בזאת כי כל הפרטים לעיל נכונים ומלאים." },
                [Languages.English]: { default: "I declare that all the details above are correct and complete." },
                [Languages.Arabic]: { default: "أصرح بأن جميع التفاصيل أعلاه صحيحة وكاملة." }
            },
            "line-2": {
                [Languages.Hebrew]: { default: "ידוע לי כי דיווח חלקי או כוזב הינה עבירה על החוק, וכן ידוע לי כי לרשות יש זכות לבדוק את נכונות הפרטים הנל בכל האמצעים העומדים לרשותה כחוק." },
                [Languages.English]: { default: "I am aware that providing false details regarding the submission of the application and using the permit not in accordance with my commitment as detailed above is an offense under the law, and the right to use the permit will be revoked and the council will have the right to cancel the permit, in addition to other remedies available to it by law." },
                [Languages.Arabic]: { default: "أنا على علم بأن تقديم تفاصيل كاذبة بشأن تقديم الطلب واستخدام التصريح ليس وفقًا لالتزامي كما هو مفصل أعلاه هو جريمة بموجب القانون، وسيتم إلغاء حق استخدام التصريح وسيكون للمجلس الحق في إلغاء التصريح، بالإضافة إلى غيرها من العلاجات المتاحة له بموجب القانون." }
            },
            "line-3": {
                [Languages.Hebrew]: { default: "הנני מאשר להשתמש בפרטים שהוזנו על ידי במסגרת הבקשה לצרכי המועצה על פי כל דין. אני מעוניין/ת לקבל תזכורות במסרון או אימייל." },
                [Languages.English]: { default: "I authorize the use of the details provided by me within the framework of the request for the purposes of the council according to the law. I wish to receive reminders via SMS or email." },
                [Languages.Arabic]: { default: "أوافق على استخدام التفاصيل التي قدمتها في إطار الطلب لأغراض المجلس وفقًا للقانون. أرغب في تلقي التذكيرات عبر الرسائل القصيرة أو البريد الإلكتروني." }
            },
            "line-4": {
                [Languages.Hebrew]: { default: "הריני מצהיר/ה ומתחייב/ת בזאת:" },
                [Languages.English]: { default: "I hereby declare and undertake:" },
                [Languages.Arabic]: { default: "أصرح وأتعهد بموجب هذا:" }
            },
            "list": {
                "item-1": {
                    [Languages.Hebrew]: { default: "1. כי הרכב שבבעלותי (או ברשותי כדין) משמש אותי באופן יומיומי לצורכי מגורים בכתובת הרשומה לעיל." },
                    [Languages.English]: { default: "1. That the vehicle owned by me (or legally in my possession) is used by me on a daily basis for residential purposes at the address registered above." },
                    [Languages.Arabic]: { default: "1. أن المركبة المملوكة لي (أو بحوزتي قانونيًا) تُستخدم من قبلي يوميًا لأغراض السكن في العنوان المسجل أعلاه." }
                },
                "item-2": {
                    [Languages.Hebrew]: { default: "2. כי אעשה שימוש בתו החניה אך ורק לצורך חניה באזור החניה אליו הוא שייך, בהתאם להוראות החוק." },
                    [Languages.English]: { default: "2. That I will use the parking permit solely for parking in the designated area, in accordance with the law." },
                    [Languages.Arabic]: { default: "2. أنني سأستخدم تصريح الوقوف فقط لأغراض الوقوف في المنطقة المخصصة، وفقًا للقانون." }
                },
                "item-3": {
                    [Languages.Hebrew]: { default: "3. כי במקרה של שינוי בעלות, כתובת או שימוש ברכב – אדווח מיידית למועצה ואחזיר את תו החניה." },
                    [Languages.English]: { default: "3. In case of a change in ownership, address, or use of the vehicle, I will immediately report to the council and return the parking permit." },
                    [Languages.Arabic]: { default: "3. في حالة تغيير الملكية أو العنوان أو استخدام المركبة، سأبلغ المجلس فورًا وأعيد تصريح الوقوف." }
                },
                "item-4": {
                    [Languages.Hebrew]: { default: "4. כי אני מודע/ת לכך ששימוש בתו החניה בניגוד להוראות חוק העזר או מסירת מידע כוזב עלול לגרור ביטול התו ו/או קנס כספי." },
                    [Languages.English]: { default: "4. That I am aware that using the parking permit contrary to the provisions of the by-law or providing false information may result in the cancellation of the permit and/or a financial penalty." },
                    [Languages.Arabic]: { default: "4. أنني على علم بأن استخدام تصريح الوقوف بما يخالف أحكام القانون أو تقديم معلومات كاذبة قد يؤدي إلى إلغاء التصريح و/أو غرامة مالية." }
                },
                "item-5": {
                    [Languages.Hebrew]: { default: "5. להודיע למשרדי האגף בשינוי מקום מגורים לכתובת אחרת ,שאינה בתחום איזור החניה ,במכירת הרכב, או במקרה של תום תוקף השכירות מבעוד מועד." },
                    [Languages.English]: { default: "5. To notify the department offices in case of a change of residence to another address, which is not within the parking area, in case of vehicle sale, or in case of lease expiration in advance." },
                    [Languages.Arabic]: { default: "5. لإبلاغ مكاتب القسم في حالة تغيير مكان الإقامة إلى عنوان آخر، غير موجود ضمن منطقة الوقوف، في حالة بيع المركبة، أو في حالة انتهاء صلاحية الإيجار مسبقًا." }
                },
                "item-6": {
                    [Languages.Hebrew]: { default: "6. אני מאשר/ת כי כל הפרטים לעיל נכונים ומדויקים." },
                    [Languages.English]: { default: "6. I hereby confirm that all the above details are correct and accurate." },
                    [Languages.Arabic]: { default: "6. أؤكد بموجب هذا أن جميع التفاصيل أعلاه صحيحة ودقيقة." }
                }
            }
        }
    },
    "confirm-modal": {
        "title": {
            [Languages.Hebrew]: { default: "אישור שליחת הבקשה" },
            [Languages.English]: { default: "Confirm Submission" },
            [Languages.Arabic]: { default: "تأكيد الإرسال" }
        },
        "message": {
            [Languages.Hebrew]: { default: "האם אתה בטוח שברצונך לשלוח את הבקשה?" },
            [Languages.English]: { default: "Are you sure you want to submit the request?" },
            [Languages.Arabic]: { default: "هل أنت متأكد أنك تريد تقديم الطلب؟" }
        },
        "sending-files-step": {
            [Languages.Hebrew]: { default: "שולח קבצים..." },
            [Languages.English]: { default: "Sending files..." },
            [Languages.Arabic]: { default: "جارٍ إرسال الملفات..." }
        },
        "submitting-request-step": {
            [Languages.Hebrew]: { default: "שולח בקשה..." },
            [Languages.English]: { default: "Submitting request..." },
            [Languages.Arabic]: { default: "جارٍ تقديم الطلب..." }
        },
        "approval": {
            [Languages.Hebrew]: { default: "כן, שלח" },
            [Languages.English]: { default: "Yes, Submit" },
            [Languages.Arabic]: { default: "نعم، أرسل" }
        }
    },
    "confirmation-receive-modal": {
        "title": {
            [Languages.Hebrew]: { default: "בקשתך התקבלה" },
            [Languages.English]: { default: "Your Request Has Been Received" },
            [Languages.Arabic]: { default: "تم استلام طلبك" }
        },
        "cofirmation-content-name": {
            [Languages.Hebrew]: { default: "לכבוד" },
            [Languages.English]: { default: "To" },
            [Languages.Arabic]: { default: "إلى" }
        },
        "line-1": {
            [Languages.Hebrew]: { default: "תושב/ת יקר/ה" },
            [Languages.English]: { default: "Dear Resident" },
            [Languages.Arabic]: { default: "عزيزي المقيم" }
        },
        "line-2": {
            [Languages.Hebrew]: { default: "בקשתך להנפקת תו חנייה התקבלה במשרדנו." },
            [Languages.English]: { default: "Your request for a parking permit has been received in our office." },
            [Languages.Arabic]: { default: "تم استلام طلبك للحصول على تصريح وقوف السيارات في مكتبنا." }
        },
        "line-3": {
            [Languages.Hebrew]: { default: "אנו עושים את מירב המאמצים לאשרה בהקדם, ועם אישורה של הבקשה, תשלח אליך בהודעת דואר אלקטרוני, הודעה על כך(על כן חשוב שכתובת הדואר אלקטרוני שצוינה תהיה תקינה)." },
            [Languages.English]: { default: "We are making every effort to approve it as soon as possible, and upon approval of the request, you will receive an email notification about it (therefore it is important that the email address provided is valid)." },
            [Languages.Arabic]: { default: "نحن نبذل قصارى جهدنا للموافقة عليها في أقرب وقت ممكن، وعند الموافقة على الطلب، ستتلقى إشعارًا عبر البريد الإلكتروني حول ذلك (لذلك من المهم أن يكون عنوان البريد الإلكتروني المقدم صالحًا)." }
        },
        "line-4": {
            [Languages.Hebrew]: { default: "חשוב להדגיש:" },
            [Languages.English]: { default: "Important to emphasize:" },
            [Languages.Arabic]: { default: "من المهم التأكيد:" }
        },
        "line-5": {
            [Languages.Hebrew]: { default: "עד לקבלת האישור, תו החנייה אינו בתוקף, ולא ניתן ליהנות מההטבות שהוא מקנה." },
            [Languages.English]: { default: "Until approval is received, the parking permit is not valid, and the benefits it provides cannot be enjoyed." },
            [Languages.Arabic]: { default: "حتى يتم استلام الموافقة، تصريح الوقوف غير صالح، ولا يمكن الاستفادة من المزايا التي يوفرها." }
        },
        "line-6": {
            [Languages.Hebrew]: { default: "בקשה שלא אושרה עקב אי-עמידה בקריטריונים לזכאות להנפקת תו החנייה/או בגין בקשה שמולאה על ידי המבקש באופן לא תקין." },
            [Languages.English]: { default: "A request that was not approved due to failure to meet the eligibility criteria for issuing a parking permit and/or due to a request that was filled out by the applicant in an incorrect manner." },
            [Languages.Arabic]: { default: "طلب لم يتم الموافقة عليه بسبب عدم استيفاء معايير الأهلية لإصدار تصريح وقوف السيارات و/أو بسبب طلب تم تعبئته من قبل المتقدم بطريقة غير صحيحة." }
        },
        "line-7": {
            [Languages.Hebrew]: { default: "במידה ונגבו דמי הנפקת תו החנייה הם לא יוחזרו." },
            [Languages.English]: { default: "If parking permit fees were charged, they will not be refunded." },
            [Languages.Arabic]: { default: "إذا تم تحصيل رسوم تصريح الوقوف، فلن يتم استردادها." }
        },
        "line-8": {
            [Languages.Hebrew]: { default: "מספר בקשה" },
            [Languages.English]: { default: "Request Number" },
            [Languages.Arabic]: { default: "رقم الطلب" }
        },
        "line-9": {
            [Languages.Hebrew]: { default: "שולם" },
            [Languages.English]: { default: "Paid" },
            [Languages.Arabic]: { default: "تم الدفع" }
        },
        "line-10": {
            [Languages.Hebrew]: { default: "מספר אסמכתא:" },
            [Languages.English]: { default: "Receipt Number:" },
            [Languages.Arabic]: { default: "رقم الإيصال:" }
        },
        "line-11": {
            [Languages.Hebrew]: { default: "נשמח להמשיך לעמוד לשירותכם." },
            [Languages.English]: { default: "We look forward to continuing to serve you." },
            [Languages.Arabic]: { default: "نتطلع إلى الاستمرار في خدمتكم." }
        }
    },
    "btns": {
        "back-to-home": {
            [Languages.Hebrew]: { default: "חזרה לדף הבית" },
            [Languages.English]: { default: "Back to Home" },
            [Languages.Arabic]: { default: "العودة إلى الصفحة الرئيسية" }
        },
        "back-to-form": {
            [Languages.Hebrew]: { default: "לא, חזור לטופס" },
            [Languages.English]: { default: "No, Return to Form" },
            [Languages.Arabic]: { default: "لا، العودة إلى النموذج" }
        },
        "show-receipt": {
            [Languages.Hebrew]: { default: "הצג קבלה" },
            [Languages.English]: { default: "Show Receipt" },
            [Languages.Arabic]: { default: "عرض الإيصال" }
        }
    }
}


export default addRequestPageLang;

export const topDeclarationLang = {
    "title": {
        [Languages.Hebrew]: { default: "פרטים חשובים לפני שמתחילים" },
        [Languages.English]: { default: "Important details before you start" },
        [Languages.Arabic]: { default: "تفاصيل مهمة قبل أن تبدأ" }
    },
    "fill-form": {
        [Languages.Hebrew]: { default: "מלאו את הפרטים הבאים בצורה מפורטת שיסייעו לנו בטיפול בפנייה. *שדות חובה." },
        [Languages.English]: { default: "Fill in the following details in a detailed manner that will help us in handling the request. *Required fields." },
        [Languages.Arabic]: { default: "املأ التفاصيل التالية بطريقة مفصلة ستساعدنا في معالجة الطلب. *الحقول المطلوبة." }
    },
    "project-id-26": {
        "line-1": {
            [Languages.Hebrew]: { default: "1. התו יכנס לתוקף תוך 24 שעות מקבלת האישור במייל." },
            [Languages.English]: { default: "1. The sticker will become valid within 24 hours of receiving the approval email." },
            [Languages.Arabic]: { default: "1. ستصبح الملصق سارية المفعول خلال 24 ساعة من استلام بريد الموافقة الإلكتروني." }
        },
        "line-2": {
            [Languages.Hebrew]: { default: "2. תושב/ת יקר/ה תו תושב ללא עלות רק מגיל 67." },
            [Languages.English]: { default: "2. Dear resident, the resident sticker is free of charge only from the age of 67." },
            [Languages.Arabic]: { default: "2. عزيزي المقيم، ملصق المقيم مجاني فقط من سن 67." }
        },
        "line-3": {
            [Languages.Hebrew]: { default: "3. תו התושב יאושר רק לרכב פרטי מסוג M1." },
            [Languages.English]: { default: "3. The resident sticker will only be approved for a private vehicle of type M1." },
            [Languages.Arabic]: { default: "3. سيتم الموافقة على ملصق المقيم فقط لمركبة خاصة من نوع M1." }
        },
        "line-4": {
            [Languages.Hebrew]: { default: "4. על פי החוק, על כל תעודת זהות ניתן להנפיק עד 2 תווי חניה." },
            [Languages.English]: { default: "4. According to the law, up to 2 parking stickers can be issued per ID." },
            [Languages.Arabic]: { default: "4. وفقًا للقانون، يمكن إصدار ما يصل إلى ملصقين للوقوف لكل بطاقة هوية." }
        },
        "line-5": {
            [Languages.Hebrew]: { default: "5. תוקף התו יהיה עד 31/12/2026." },
            [Languages.English]: { default: "5. The sticker will be valid until 31/12/2026." },
            [Languages.Arabic]: { default: "5. سيكون التوقيت صالحًا حتى 31/12/2026." }
        }
    },
    "project-id-51": {
        "line-1": {
            [Languages.Hebrew]: { default: "1. אישור לתו יינתן בתום השלמת הגשת כל המסמכים הנדרשים ובדיקתם ע'י העירייה." },
            [Languages.English]: { default: "1. Approval for the sticker will be given upon completion of submitting all required documents and their review by the municipality." },
            [Languages.Arabic]: { default: "1. سيتم منح الموافقة على الملصق عند إكمال تقديم جميع المستندات المطلوبة ومراجعتها من قبل البلدية." }
        },
        "line-2": {
            [Languages.Hebrew]: { default: "2. התו יכנס לתוקף תוך 24 שעות מקבלת האישור." },
            [Languages.English]: { default: "2. The sticker will become valid within 24 hours of receiving the approval." },
            [Languages.Arabic]: { default: "2. ستصبح الملصق سارية المفعول خلال 24 ساعة من استلام الموافقة." }
        }
    },
    "project-id-32": {
        "title": {
            [Languages.Hebrew]: { default: "עלויות לפי סוגי התווים:" },
            [Languages.English]: { default: "Costs by sticker type:" },
            [Languages.Arabic]: { default: "التكاليف حسب نوع الملصق:" }
        },
        "l1": {
            [Languages.Hebrew]: { default: `תו תושב - ${formatCurrencyNis(50)}` },
            [Languages.English]: { default: `Resident sticker - ${formatCurrencyNis(50)}` },
            [Languages.Arabic]: { default: `ملصق المقيم - ${formatCurrencyNis(50)}` }
        },
        "l2": {
            [Languages.Hebrew]: { default: "תו גיל הזהב (מגיל 70 ומעלה) - חינם" },
            [Languages.English]: { default: "Golden Age Sticker (from age 70 and above) - Free" },
            [Languages.Arabic]: { default: "" }
        },
        "l3": {
            [Languages.Hebrew]: { default: `תו דייר צמוד רחוב (רחוב אל גליל) - ${formatCurrencyNis(200)}` },
            [Languages.English]: { default: `Resident sticker - ${formatCurrencyNis(200)}` },
            [Languages.Arabic]: { default: `ملصق المقيم - ${formatCurrencyNis(200)}` }
        },
        "l4": {
            [Languages.Hebrew]: { default: `תו בעל עסק - ${formatCurrencyNis(300)}` },
            [Languages.English]: { default: `Business owner - ${formatCurrencyNis(300)}` },
            [Languages.Arabic]: { default: `صاحب العمل - ${formatCurrencyNis(300)}` }
        }
    }
}